/* eslint-disable */
export default {
  cancel: '취소',
  reply: '회신',
  onMyWay: '가는 중',
  customMessage: '사용자 지정 메시지',
  callMeBackIn: '다음 이후 다시 전화해 주세요.',
  willCallYouBackIn: '다음 이후 다시 전화하겠습니다.',
  min: '분',
  hours: '시간',
  days: '일',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom Message"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in"@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
// @key: @#@"hours"@#@ @source: @#@"hours"@#@
// @key: @#@"days"@#@ @source: @#@"days"@#@
